import * as Msal from "msal";
import { authority, clientId, redirectUri } from "../../auth_config.json";

const msalConfig = {
  auth: {
    clientId,
    authority,
    redirectUri,
    navigateToLoginRequestUrl: true,
  },
};

const loginRequest = {
  scopes: ["openid", "profile", "User.Read"],
};

const apiRequest = {
  scopes: [`${clientId}/.default`],
};

const myMSALObj = new Msal.UserAgentApplication(msalConfig);

function signIn() {
  myMSALObj
    .loginRedirect(loginRequest)
    .then((loginResponse) => {
      console.log("id_token acquired at: " + new Date().toString());
      console.log(loginResponse);

      if (myMSALObj.getAccount()) {
        console.log(myMSALObj.getAccount());
        //showWelcomeMessage(myMSALObj.getAccount());
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

myMSALObj.handleRedirectCallback(authRedirectCallBack);

function authRedirectCallBack(error, response) {
  if (error) {
    console.log(error);
  } else {
    if (response.tokenType === "id_token") {
      console.log("id_token acquired at: " + new Date().toString());
    } else if (response.tokenType === "access_token") {
      console.log("access_token acquired at: " + new Date().toString());
    } else {
      console.log("token type is:" + response.tokenType);
    }
  }
}

export { myMSALObj, signIn, loginRequest, apiRequest };
